import React, { Component } from 'react';
import DocumentTitle from 'react-document-title';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import logo from './two-sword-logo.svg';
import style from './App.css';
import layerArray from './fixtures/selectionLayers';
import ValueGrid from './components/valuegrid';

class App extends Component {
  render() {
    document.body.style.backgroundColor = this.props.currentDisplayedLayer <= 3 ? 'white' : '#262e40';
    return (
      <DocumentTitle title="Valuemaster">
        <div className={style.App} >
          { this.props.currentDisplayedLayer <= 3 ?
            <div className={style.AppHeader}>
              <img src={logo} className={style.AppLogo} alt="logo" />
              <h2>Who Are You?</h2>
            </div>
          :
            <div className={style.ResultHeader}>
              <h3>{ layerArray[this.props.currentDisplayedLayer].headerText }</h3>
            </div>
        }
          <ValueGrid />
        </div>
      </DocumentTitle>
    );
  }
}

// This is totally optional, but forces react to check the prop types
// when running in debug
App.propTypes = {
  currentDisplayedLayer: PropTypes.number.isRequired,
};


function mapStateToProps(state, props) {
  return {
    currentDisplayedLayer: state.valueSet.displayLayer,
  };
}
function mapDispatchToProps(dispatch) {
  return { };
}
export default connect(mapStateToProps, mapDispatchToProps)(App);




// WEBPACK FOOTER //
// ./src/App.js